<template>
  <div>
    <button 
      @click="confirmDelete" 
      class="btn btn-default font-weight-normal trash-button"
    >
      <i class="fa fa-trash-o"></i>
    </button>
  </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  props: ['automationId'],

  methods: {
    confirmDelete() {
      Swal.fire({
        icon: 'question',
        title: this.__('Deseja excluir essa campanha?'),
        width: 350,
        buttonsStyling: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: this.__('Continuar'),
        cancelButtonColor: 'transparent',
        cancelButtonText: this.__('Cancelar'),
        showCancelButton: true,
        customClass: {
          container: 'container-swal2',
          confirmButton: 'btn btn-primary ',
          cancelButton: 'btn swal2-btn-cancel-transparent swal2-btn-full-line',
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          navigator.locks.request('automation-delete', async lock => {
            try {
              const response = await this.$http.delete(`/automation/${this.automationId}`);
              if (response.status === 200) {
                localStorage.setItem('toastMessage', response.body.message);
                window.location.reload();
                await new Promise(resolve => setTimeout(resolve, 3000));
              }
            } catch (error) {
              Alert.error(this.__('Algo deu errado. Por favor, tente novamente mais tarde.'));
            }
          });
        }
      });
    }
  }
}
</script>